import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Dimmer, Loader } from 'semantic-ui-react';
import { useUsers } from '../../../providers/UsersProvider';
import { AddButton } from '../../../components/AddButton/AddButton';
import { useAuth } from '../../../providers/AuthenticationProvider';
const WEB_PAGE = 'Users';

export const Users = () => {
    const { checkAuth, getUserType } = useAuth();
    const { users, pageSize, pageIndex, setPageSize, setPageIndex, total, queryUsers, sortState, setSortState } = useUsers();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    useEffect(() => {
        setLoading(true);
        const fetchUsers = async () => {
            await queryUsers();
            setLoading(false);
        }

        fetchUsers();
    }, [pageSize, pageIndex, sortState, queryUsers]);

    const handlePageChange = (e) => {
        setPageIndex(e.page.skip / e.page.take);
    };

    const handleSortChange = (e) => {
        setSortState(e.sort.length ? [{ fieldName: e.sort[0].field, dir: e.sort[0].dir }] : []);
    };

    const sort = sortState.map(s => ({ field: s.fieldName, dir: s.dir }));

    return (
        <div>
            <div className="pageHeader">
                <h1>Users</h1>
                <AddButton to="/users/create-user">Create a User</AddButton>
            </div>
            <div style={{ position: 'relative' }}>
                <Dimmer active={loading} inverted>
                    <Loader />
                </Dimmer>
                <Grid
                    data={users}
                    total={total}
                    skip={pageIndex * pageSize}
                    take={pageSize}
                    pageable={true}
                    sortable={true}
                    sort={sort}
                    onPageChange={handlePageChange}
                    onSortChange={handleSortChange}
                    onRowClick={(e) => navigate('/users/edit/', { state: { user: e.dataItem } })}
                >
                    <Column field="firstname" title="First Name" />
                    <Column field="lastname" title="Last Name" />
                    <Column field="email" title="User Email" width={300} />
                    <Column field="phoneNumber" title="Contact Number" />
                    <Column field="roleName" title="User Role" sortable={false} />
                    <Column field="inactive" title="Account Disabled" />
                </Grid>
            </div>
        </div>
    );
};
